import { render } from "./AddDocumentParticipantDialog.vue?vue&type=template&id=6a11308e"
import script from "./AddDocumentParticipantDialog.vue?vue&type=script&lang=js"
export * from "./AddDocumentParticipantDialog.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__